import type { AnyRouter } from "@tanstack/react-router";

import { Auth0Provider } from "@auth0/auth0-react";
import { type ReactNode } from "react";

import { config } from "@/config";

type AuthProviderProps = {
  children: ReactNode;
  router: AnyRouter;
};

export function AuthProvider({ children, router }: AuthProviderProps) {
  return (
    <Auth0Provider
      authorizationParams={{
        audience: config.AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
        scope: config.AUTH0_SCOPE,
      }}
      cacheLocation="localstorage"
      domain={config.AUTH0_DOMAIN}
      clientId={config.AUTH0_CLIENT_ID}
      onRedirectCallback={(appState) => {
        router.navigate({ replace: true, to: appState?.returnTo || "/" });
      }}
    >
      {children}
    </Auth0Provider>
  );
}
